require('./bootstrap');
// import './bootstrap';

// Bugsnag

/*
var bugsnag = require('@bugsnag/js');

if (process.env.NODE_ENV === 'production') {
    var bugsnagClient = bugsnag({
        apiKey: 'b3e0dd39d00bf4f4ec10e1249110ddee',
        releaseStage: process.env.NODE_ENV
    })
}
*/

if (process.env.NODE_ENV === 'production') {
    var Bugsnag = require('@bugsnag/js');
    Bugsnag.start({
        apiKey: 'b3e0dd39d00bf4f4ec10e1249110ddee',
        releaseStage: process.env.NODE_ENV
    });
}

// Bootbox
window.bootbox = require('bootbox');

// Bootstrap Date Range Picker
require('bootstrap-daterangepicker');

// Bootstrap Table

window.bootstrap = {
    Tooltip: {
        VERSION: "5"
    }
}

require('bootstrap-table');

// Chosen
require('chosen-js');

// JavaScript Cookie
window.Cookies = require('js-cookie');

// jQuery - Date Time Picker
require("jquery-datetimepicker");

// jQuery UI - autocomplete
require("jquery-ui/ui/widgets/autocomplete");

// jQuery UI - datepicker
require("jquery-ui/ui/widgets/datepicker");

// jQuery UI - sortable
require("jquery-ui/ui/widgets/sortable");

// Moment.js
require('moment');

// PurceCounter
import PureCounter from "@srexi/purecounterjs";
const pure = new PureCounter();

// SweetAlert2
window.Swal = require('sweetalert2');

// App

require('./app/actions.js');
require('./app/button_toggle.js');
require('./app/chosen.js');
require('./app/colorCellStyle.js');
require('./app/confirm.js');
require('./app/datepicker.js');
require('./app/daterangepicker.js');
require('./app/dialog_google_maps.js');
require('./app/font_awesome.js');
require('./app/i18n.js');
require('./app/number_format.js');
require('./app/number_format_to_decimal.js');
require('./app/ready.js');
require('./app/sidebar.js');
require('./app/sprintf.js');
require('./app/tables.js');
require('./app/tabs.js');
require('./app/tooltip.js');
require('./app/validation.js');

// Formatters

require('./app/formatters/alarmLocation.js');
require('./app/formatters/alarmNumber.js');
require('./app/formatters/alarmPriority.js');
require('./app/formatters/alarmRowStyle.js');
require('./app/formatters/bookingNumber.js');
require('./app/formatters/boolean.js');
require('./app/formatters/color.js');
require('./app/formatters/containerNumber.js');
require('./app/formatters/containerType.js');
require('./app/formatters/customerContactName.js');
require('./app/formatters/delete.js');
require('./app/formatters/dryContainerStartMeasurement.js');
require('./app/formatters/dryContainerStopMeasurement.js');
require('./app/formatters/edit.js');
require('./app/formatters/employeeName.js');
require('./app/formatters/fleetEdit.js');
require('./app/formatters/fleetName.js');
require('./app/formatters/googleMaps.js');
require('./app/formatters/homeDryContainersDetail.js');
require('./app/formatters/location.js');
require('./app/formatters/outdated.js');
require('./app/formatters/reeferStartMeasurement.js');
require('./app/formatters/reeferStopMeasurement.js');
require('./app/formatters/rowBackgroundColor.js');
require('./app/formatters/rowStyle.js');
require('./app/formatters/shipName.js');
require('./app/formatters/show.js');
require('./app/formatters/thermoKingAlarmDetail.js');
require('./app/formatters/vehicleName.js');
require('./app/formatters/vehicleStartMeasurement.js');
require('./app/formatters/vehicleStopMeasurement.js');
